import { useEffect, useMemo, useState } from 'react';

import { getLevelPlayer } from 'services/levels.service';
import { getPublicProfile } from 'services/profile.service';

export type ProfileSummary = {
  nivel: any;
  grupo: any;
  grupoTotal: any;
};

type FallbackGroup = { nome?: string; total?: number } | undefined;

type ProfileReading = { profile: any; nivel: any };

/**
 * Nível e grupo do card de perfil. `get_profile_public` já traz o nível; `get_level` só sai
 * quando ele não vem (DCE-14). Relê só quando a chave ou o ciclo mudam (DCE-28, DCE-54); o grupo
 * do `userInfo` completa o que o perfil público não trouxer.
 */
export function useProfileSummary(chave?: string, cycleId?: string, fallbackGroup?: FallbackGroup) {
  const [reading, setReading] = useState<ProfileReading>();

  useEffect(() => {
    if (!chave || !cycleId) return;

    let active = true;

    async function load(playerKey: string, cycle: string) {
      const profile = await getPublicProfile(playerKey, cycle);
      const nivel = profile?.level ? profile.level : (await getLevelPlayer())?.nivel;

      if (active) setReading({ profile, nivel });
    }

    load(chave, cycleId).catch(error => console.error('Erro ao carregar o nível e o grupo do perfil:', error));

    return () => {
      active = false;
    };
  }, [chave, cycleId]);

  const fallbackName = fallbackGroup?.nome;
  const fallbackTotal = fallbackGroup?.total;

  return useMemo<ProfileSummary | undefined>(() => {
    if (!reading) return undefined;

    const { profile, nivel } = reading;
    return {
      nivel,
      grupo: profile?.grupo ? profile.grupo : fallbackName,
      grupoTotal: profile?.grupo_total ? profile.grupo_total : fallbackTotal,
    };
  }, [reading, fallbackName, fallbackTotal]);
}
